'use client';

import Cookies from 'js-cookie';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { SET_AS_DEFAULT_VENUE_SEARCH_PARAM, USER_SESSION } from '../constants';
import { useIsVenueRouterPage } from './useIsVenueRouterPage';

/**
 * Initializes the venue-router session from the current URL and removes its one-time query parameter.
 */
export const useVenueRouterSessionHandler = (): void => {
    const isVenueRouterPage = useIsVenueRouterPage();
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    useEffect(() => {
        const hasSearchParam = searchParams.has(SET_AS_DEFAULT_VENUE_SEARCH_PARAM);

        if ((hasSearchParam || !isVenueRouterPage) && !Cookies.get(USER_SESSION)) {
            Cookies.set(USER_SESSION, new Date().toISOString());
            sessionStorage.setItem(USER_SESSION, new Date().toISOString());
        }
        if (hasSearchParam) {
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete(SET_AS_DEFAULT_VENUE_SEARCH_PARAM);
            const query = newSearchParams.toString();
            router.replace(query ? `${pathname}?${query}` : pathname, { scroll: false });
        }
    }, [searchParams]);
};
